import { render, staticRenderFns } from "./CallToActionBlock.vue?vue&type=template&id=62e07334&scoped=true"
import script from "./CallToActionBlock.vue?vue&type=script&lang=js"
export * from "./CallToActionBlock.vue?vue&type=script&lang=js"
import style0 from "./CallToActionBlock.vue?vue&type=style&index=0&id=62e07334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e07334",
  null
  
)

export default component.exports